export default __webpack_public_path__ + "static/aikido-miran-11073481983141a5faf20bc7ef4e862d.jpg";